interface SelectNativeFilterProps {
  value: string
  onChange: (v: string) => void
  options: { label: string; value: string }[]
  label?: string
  placeholder?: string
}

/**
 * Native `<select>` filter for FilterManager. Lightweight fallback when react-select
 * isn't desired (e.g. fewer options, no theme requirement).
 *
 * Use the `'selectNative'` key in `activeFilters`. For the styled / themed
 * variant use `'select'`; for multi-value use `'selectMulti'`.
 *
 * @example
 * <FilterManager
 *   activeFilters={[{ filter: 'selectNative', fieldName: 'status' }]}
 *   filterProps={{ status: { label: 'Статус', options: [...] } }}
 *   onApplyFilters={(f) => console.log(f.status)}
 * />
 */
export function SelectNativeFilter({
  value,
  onChange,
  options,
  label,
  placeholder = 'Все',
}: SelectNativeFilterProps) {
  return (
    <>
      {label && (
        <label className='fs-6 form-label fw-bolder text-dark'>{label}</label>
      )}
      <select
        className='form-select form-select-solid'
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value=''>{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </>
  )
}
